"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import useScrollDirection from "@/features/landing/hooks/useScrollDirection"; // adjust path to where you moved it

export default function FabNewThread() {
  const dir = useScrollDirection({ threshold: 6 });
  const hidden = dir === "down";

  // optional: hide on the new-thread page itself
  const pathname = usePathname();
  if (pathname === "/community/new") return null;

  return (
    <Link
      href="/community/new"
      aria-label="Create new thread"
      title="New Thread"
      className={[
        "md:hidden fixed right-4 bottom-4 z-40",
        "transition-all duration-200 ease-out",
        hidden ? "translate-y-24 opacity-0 pointer-events-none" : "translate-y-0 opacity-100",
      ].join(" ")}
      style={{ marginBottom: "env(safe-area-inset-bottom)" }}
    >
      <span
        className={[
          "grid place-items-center h-14 w-14 rounded-full",
          "bg-primary text-white shadow-lg shadow-black/30",
          "border border-white/10",
          "hover:brightness-110 active:scale-95",
        ].join(" ")}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </span>
    </Link>
  );
}
